"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactIntl = require("react-intl");

var _Info = _interopRequireDefault(require("@react/react-spectrum/Icon/Info"));

var _OverlayTrigger = _interopRequireDefault(require("@react/react-spectrum/OverlayTrigger"));

var _Popover = _interopRequireDefault(require("@react/react-spectrum/Popover"));

var _UnmappedTitle = _interopRequireDefault(require("./UnmappedTitle.scss"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 * Copyright 2020 Adobe
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 ***************************************************************************/
var UnmappedTitle = function UnmappedTitle() {
  var _useIntl = (0, _reactIntl.useIntl)(),
      formatMessage = _useIntl.formatMessage;

  var popoverText = formatMessage({
    id: 'comments.list.unmapped_explination'
  });
  return /*#__PURE__*/_react.default.createElement("div", {
    className: _UnmappedTitle.default.component
  }, /*#__PURE__*/_react.default.createElement(_reactIntl.FormattedMessage, {
    id: "comments.list.unmapped"
  }), /*#__PURE__*/_react.default.createElement(_OverlayTrigger.default, {
    className: _UnmappedTitle.default.overlayTrigger,
    placement: "top",
    trigger: "hover"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: _UnmappedTitle.default.iconWrapper
  }, /*#__PURE__*/_react.default.createElement(_Info.default, {
    className: _UnmappedTitle.default.icon,
    size: "S"
  })), /*#__PURE__*/_react.default.createElement(_Popover.default, null, popoverText)));
};

var _default = UnmappedTitle;
exports.default = _default;